var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHomeslider3({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.6666 12.8333H15.1249C15.883 12.8333 16.4999 12.2164 16.4999 11.4583V3.20834C16.4999 2.45026 15.883 1.83334 15.1249 1.83334H3.20825C2.45017 1.83334 1.83325 2.45026 1.83325 3.20834V16.5L6.72184 12.8333H14.6666ZM6.11134 11L3.66659 12.8333V3.66668H14.6666V11H6.11134Z",
    fill: "#40DFEF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.7916 7.33334H18.3333V12.8343C18.3333 13.8426 17.5147 14.6612 16.5091 14.6667H7.33325V15.125C7.33325 15.8831 7.95017 16.5 8.70825 16.5H15.278L20.1666 20.1667V8.70834C20.1666 7.95026 19.5497 7.33334 18.7916 7.33334Z",
    fill: "#40DFEF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeslider3);
export default __webpack_public_path__ + "static/media/homeslider3.26d60e81edb089f8e7c62e4049692cbb.svg";
export { ForwardRef as ReactComponent };